'use client'
import {} from 'react'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { mainProductConfig } from 'constants/mainProductConfig'
import { isExternal } from 'utils/conversions'
import { selectOverride } from './Typography'
import { INLINES } from '@contentful/rich-text-types'

export function HyperLinkClient({
  node,
  children,
  props,
  styleOverride,
  variantOverride,
  richText,
}) {
  const currentURL = useCurrentUrl()
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'
  const linkId = node?.content[0].value
  const url = node?.data.uri

  return (
    <AchieveLink
      track={{
        list_name: 'Inline Link',
        click_id: linkId,
        click_text: `${mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']}| ${linkId}`,
        click_type: 'Button Click',
        click_position: '0',
        nav_link_section: 'CTA Card - In-Content',
        track_event: 'page_nav_click',
        event_action: 'button_click',
        event_type: 'button_click',
      }}
      sx={selectOverride(INLINES.HYPERLINK, styleOverride, 'sx')}
      variant={selectOverride(INLINES.HYPERLINK, variantOverride, 'variant')}
      data-testid={`Link-${url}-${linkId}`}
      href={url}
      target={isExternal(url, currentURL) ? '_blank' : '_self'}
      {...props}
      component={richText[INLINES.HYPERLINK].component}
    >
      {children[0] || children}
    </AchieveLink>
  )
}
